import Api from "./api.service";

class Features {
  static getFeatures(tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/product_metadata_types`);
  }

  static getFilteredFeatures(tenantSlug, params) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/product_metadata_types`, {
      params
    });
  }

  static getFeature(slug, tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/product_metadata_types/${slug}`);
  }

  static createFeature(featureAttributes, tenantSlug) {
    const payload = {
      data: {
        type: "product_metadata_types",
        attributes: featureAttributes
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/product_metadata_types`, payload);
  }

  static updateFeature(slug, featureAttributes, tenantSlug) {
    const payload = {
      data: {
        type: "product_metadata_types",
        id: slug,
        attributes: featureAttributes
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/product_metadata_types/${slug}`, payload);
  }
}

const FeaturesService = Object.freeze(Features);
export default FeaturesService;
